import script from "./InputSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__